<app-home-hint [isFirstTime]="true"></app-home-hint>
